module.exports = __webpack_public_path__ + "static/media/logo-s.ffa03d98.png";